import { Card, CardContent, Grid, SvgIcon } from '@mui/material'
import {
  Accessibility,
  AccountBox,
  Assessment,
  Business,
  Code,
  Description,
  Drafts,
  Face,
  Hotel,
  Inbox,
  Info,
  Label,
  LocalHospital,
  Loyalty,
  MonetizationOn,
  PersonOutline,
  RecordVoiceOver,
  Send,
  Settings,
  Storage,
  Group,
  Contacts,
  CreateNewFolder,
} from '@mui/icons-material'
import { ClipboardOutline, Stethoscope } from 'mdi-material-ui'
import { inject } from 'mobx-react'
import { RouterStore } from 'mobx-react-router'
import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { IStores } from '../Stores'
import { IUser } from 'src/Definitions'
import Constants from '../config'

interface IAdminPagesProps {
  routerStore?: RouterStore
  setCanSwitchOrganizations?: (canSwitch: boolean) => void
  user?: IUser
}

interface IAdminPagesState {
  pages: IAdminPage[]
}

interface IAdminPage {
  icon: React.ComponentType
  path: string
  title: string
}

@inject((stores: IStores) => ({
  routerStore: stores.routing,
  setCanSwitchOrganizations: stores.global.setCanSwitchOrganizations,
}))
class AdminPages extends Component<IAdminPagesProps, IAdminPagesState> {
  constructor(props: IAdminPagesProps) {
    super(props)

    var pages: IAdminPage[] = []

    // Add Advanced Report Config card if user has either role
    if (
      this.props.user?.roles.includes(Constants.ObxRoles.WorkflowAdmin) ||
      this.props.user?.roles.includes(Constants.ObxRoles.Administrator)
    ) {
      pages.push({
        icon: Assessment,
        path: '/admin/advancedReportConfig',
        title: 'Adv Report Config',
      })
    }

    if (this.props.user?.roles.includes(Constants.ObxRoles.WorkflowAdmin)) {
      pages.push({
        icon: Inbox,
        path: '/admin/workflow',
        title: 'Workflow Administration',
      })
    }

    if (this.props.user?.roles.includes(Constants.ObxRoles.Administrator)) {
      pages.push({
        icon: Info,
        path: '/admin/companyInfo',
        title: 'Company Information',
      })
    }

    if (
      this.props.user?.organizationId === '0e4626af-6947-3bfb-1c1e-4438f04ad89c' &&
      this.props.user?.roles.includes(Constants.ObxRoles.Administrator)
    ) {
      pages.push({
        icon: CreateNewFolder,
        path: '/invoice/invoiceType',
        title: 'Invoice Type',
      })
      pages.push({
        icon: Group,
        path: '/admin/referralSource',
        title: 'Referral Source',
      })
      pages.push({
        icon: Contacts,
        path: '/admin/referralSpeciality',
        title: 'Referral Speciality',
      })
      pages.push({
        icon: AccountBox,
        path: '/users',
        title: 'Users',
      })
    }
    if (
      this.props.user?.roles.includes(
        Constants.OmxRoles.CaseCoordinator ||
          Constants.OmxRoles.CaseManager ||
          Constants.ObxRoles.Administrator
      )
    ) {
      pages.push({
        icon: Drafts,
        path: '/admin/receivedInvoicePaymentChecks',
        title: 'Received Checks',
      })
    } else {
      if (this.props.user?.roles.includes(Constants.ObxRoles.Administrator)) {
        pages.push({
          icon: RecordVoiceOver,
          path: '/admin/referringDoctors',
          title: 'Referring Doctors',
        })
        pages.push({
          icon: Business,
          path: '/admin/employers',
          title: 'Employers',
        })
        pages.push({
          icon: Description,
          path: '/admin/insuranceCompanies',
          title: 'Insurance Companies',
        })
        pages.push({
          icon: Face,
          path: '/admin/nurseCaseManagers',
          title: 'Nurse Case Managers',
        })
        pages.push({
          icon: Storage,
          path: '/admin/preexistingconditions',
          title: 'Pre-Existing Conditions',
        })
        pages.push({
          icon: ClipboardOutline,
          path: '/admin/components',
          title: 'Components and Tasks',
        })
        pages.push({
          icon: Loyalty,
          path: '/admin/exclusionCodes',
          title: 'Multiple Procedure Discount Exclusions',
        })
        pages.push({
          icon: PersonOutline,
          path: '/admin/contactTypes',
          title: 'Contact Types',
        })
        pages.push({
          icon: Accessibility,
          path: '/admin/bodyParts',
          title: 'Body Parts',
        })
        pages.push({
          icon: Label,
          path: '/admin/tags',
          title: 'Tags',
        })
        pages.push({
          icon: Code,
          path: '/admin/cptCodes',
          title: 'CPT Codes',
        })
        pages.push({
          icon: Stethoscope,
          path: '/admin/dxCodes',
          title: 'DX Codes',
        })
        pages.push({
          icon: MonetizationOn,
          path: '/admin/medicareCost',
          title: 'Medicare Cost',
        })
        pages.push({
          icon: Hotel,
          path: '/procedures',
          title: 'Procedures',
        })
        pages.push({
          icon: LocalHospital,
          path: '/providers',
          title: 'Providers',
        })
        pages.push({
          icon: Send,
          path: '/admin/sentChecks',
          title: 'Sent Checks',
        })
        pages.push({
          icon: Drafts,
          path: '/admin/receivedChecks',
          title: 'Received Checks',
        })
        pages.push({
          icon: AccountBox,
          path: '/users',
          title: 'Users',
        })
      } else {
        if (
          this.props.user?.roles.includes(Constants.ObxRoles.GeneralFinance) ||
          this.props.user?.roles.includes(Constants.ObxRoles.FinanceTier1) ||
          this.props.user?.roles.includes(Constants.ObxRoles.FinanceTier2) ||
          this.props.user?.roles.includes(Constants.ObxRoles.FinanceTier3) ||
          this.props.user?.roles.includes(Constants.ObxRoles.FinanceManager)
        ) {
          pages.push({
            icon: Send,
            path: '/admin/sentChecks',
            title: 'Sent Checks',
          })
          pages.push({
            icon: Drafts,
            path: '/admin/receivedChecks',
            title: 'Received Checks',
          })
        }

        if (this.props.user?.roles.includes(Constants.ObxRoles.ProviderInfoUpdater)) {
          pages.push({
            icon: LocalHospital,
            path: '/providers',
            title: 'Providers',
          })
        }
      }
    }

    this.state = {
      pages,
    }
  }

  public componentDidMount() {
    this.props.setCanSwitchOrganizations!(true)
  }

  public componentWillUnmount() {
    this.props.setCanSwitchOrganizations!(false)
  }

  public render() {
    return (
      <div>
        <Helmet>
          <title>Admin</title>
        </Helmet>
        <ResponsiveAppBar title="Admin" pageIcon={<Settings />} />
        <Grid container>{this.renderAdminPageCards(this.state.pages)}</Grid>
      </div>
    )
  }

  private renderAdminPageCards(pages: IAdminPage[]) {
    const setPage = (page: IAdminPage) => () => {
      if (page.title == 'Workflow Administration') {
        window.open(
          process.env.REACT_APP_WORKFLOW_ADMIN_URL || 'http://localhost:4200',
          '_blank'
        )
      } else {
        this.props.routerStore!.push(page.path)
      }
    }

    return (
      <>
        {pages.map((page, index) => {
          return (
            <Grid
              item
              xs={2}
              key={index}
              sx={{
                minWidth: '240px',
                padding: '20px',
                textAlign: 'center',
              }}
            >
              <Card
                onClick={setPage(page)}
                sx={{
                  borderRadius: '20px',
                  cursor: 'pointer',
                  height: '230px',
                  paddingTop: '20px',
                }}
              >
                <CardContent sx={{ height: '100%' }}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-between"
                    sx={{ height: '100%' }}
                  >
                    <Grid item>
                      <SvgIcon
                        color="primary"
                        component={page.icon}
                        sx={{ fontSize: '96px' }}
                        children={[]}
                      />
                    </Grid>
                    <Grid item>{page.title}</Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )
        })}
      </>
    )
  }
}
const InjectedAdminPages = inject<
  IStores,
  IAdminPagesProps,
  Partial<IAdminPagesProps>,
  any
>((stores: IStores) => ({
  user: stores.global.user,
}))(AdminPages)

export default InjectedAdminPages
